import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=16a0930a&"
import script from "../model/articlePc.js?vue&type=script&lang=js&"
export * from "../model/articlePc.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports